@if (user.givenName) {
  <div class="row">
    <div class="col-6 col-md-3">
      <p><strong>Given Name</strong></p>
      <p>{{ user.givenName }}</p>
    </div>
    <div class="col-6 col-md-3">
      <p><strong>Family Name</strong></p>
      <p>{{ user.familyName }}</p>
    </div>
  </div>
}
<div class="row">
  <div class="col-12">
    <p><strong>Email</strong></p>
    <p>{{ user.email }}</p>
  </div>
</div>
